const features = [
  {
    icon: 'ri-stack-line',
    title: '海量内容 每日更新',
    desc: '汇聚51吃瓜在线、吃瓜在线等多平台精华内容，瓜田每日更新300+条八卦资讯，让你不错过任何热门话题',
  },
  {
    icon: 'ri-folder-2-line',
    title: '分类清晰 快速定位',
    desc: '按娱乐圈、网红圈、综艺、影视、社会热点等多维度分类，轻松找到感兴趣的51在线吃瓜内容',
  },
  {
    icon: 'ri-hd-line',
    title: '高清流畅 体验出色',
    desc: '所有吃瓜视频内容高清画质呈现，流畅加载不卡顿，吃瓜群众在线观看体验最佳',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全私密 放心吃瓜',
    desc: '浏览记录严格保护，无需注册即可浏览，让吃瓜群众安心看热闹，隐私安全有保障',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <span className="text-xs font-label text-primary-600 bg-primary-50 px-3 py-1 rounded-full">为什么选择我们</span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mt-3">
            平台特色
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-[560px] mx-auto">
            为吃瓜群众量身打造的优质在线吃瓜体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="group p-6 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-50 text-primary-600 mb-4 group-hover:bg-primary-100 transition-colors">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-label font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}